export default {
    parts: [
        'accordion',
        'accordionItem',
        'accordionButton',
        'headerRow',
        'headerTitle',
        'headerIconCollapsed',
        'headerIconExpanded',
        'accordionPanel',
        'contentText'
    ],
    baseStyle: {
        accordion: {
            mt: 0,
            mb: 4
        },
        accordionItem: {
            border: 'none'
        },
        accordionButton: {
            variant: 'link',
            textDecoration: 'none',
            px: 0,
            py: 0,
            minH: 'auto'
        },
        headerRow: {
            w: 'full',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        headerTitle: {
            textStyle: 'bodySmRegular',
            textTransform: 'none'
        },
        headerIconCollapsed: {
            boxSize: '24px',
            transition: 'transform 0.2s ease',
            transform: 'rotate(0deg)'
        },
        headerIconExpanded: {
            boxSize: '24px',
            transition: 'transform 0.2s ease',
            transform: 'rotate(180deg)'
        },
        accordionPanel: {
            px: 0,
            pt: 2,
            pb: 0,
            height: '418px',
            overflowY: 'auto'
        },
        contentText: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary'
        }
    }
}
